import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cs-table-header-cell',
  templateUrl: 'cs-table-header-cell.html',
  host: { 'class': 'table-header-cell' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsTableHeaderCell {}
